import { useMemo } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import "./StarRating.scss";

const Star = ({ fraction = 0, size = 16 }) => {
	const clipId = useMemo(
		() =>
			`clip-star-${Math.random()
				.toString(36)
				.slice(2)}`,
		[]
	);
	const clampedFraction = Math.max(0, Math.min(1, fraction));
	const roundedSize = Math.round(size);

	return (
		<svg
			width={roundedSize}
			height={roundedSize}
			viewBox="0 0 16 16"
			xmlns="http://www.w3.org/2000/svg"
			aria-hidden="true"
		>
			<path
				d="M10.002 5.28223L10.1182 5.52051L10.3809 5.55859L14.9268 6.20703L11.6445 9.43066L11.458 9.61328L11.502 9.87109L12.2822 14.4414L8.21973 12.2881L7.98535 12.1631L7.75098 12.2881L3.71875 14.4385L4.49805 9.87207L4.54199 9.61426L4.35547 9.43066L1.07129 6.20605L5.59082 5.55859L5.85352 5.52051L5.96973 5.28223L7.98535 1.1416L10.002 5.28223Z"
				fill="none"
				stroke="currentColor"
				strokeWidth="1"
			/>

			<defs>
				<clipPath id={clipId}>
					<rect x="0" y="0" width={`${clampedFraction * 100}%`} height="100%" />
				</clipPath>
			</defs>

			<path
				d="M7.98596 0L10.4517 5.06345L15.9996 5.8554L11.9946 9.7872L12.9472 15.36L7.98596 12.7295L3.05533 15.36L4.00495 9.78762L0 5.8554L5.52023 5.06345L7.98596 0Z"
				fill="currentColor"
				clipPath={`url(#${clipId})`}
			/>
		</svg>
	);
};

Star.propTypes = {
	fraction: PropTypes.number,
	size: PropTypes.number,
};

export const StarRating = ({ rating = 0, maxRate = 5, size = 16, className }) => {
	const clampedRating = Math.max(0, Math.min(maxRate, rating));

	const starRatingClassName = classNames("star-rating", className);

	return (
		<div
			className={starRatingClassName}
			role="img"
			aria-label={`Note ${clampedRating} sur ${maxRate}`}
		>
			{Array.from({ length: maxRate }, (_, starIndex) => {
				const starFillFraction = Math.max(0, Math.min(1, clampedRating - starIndex));

				return <Star key={starIndex} fraction={starFillFraction} size={size} />;
			})}
		</div>
	);
};

StarRating.propTypes = {
	rating: PropTypes.number,
	maxRate: PropTypes.number,
	size: PropTypes.number,
};
